<template>
  <v-container fluid>
    <UserProfile></UserProfile>
    <v-row justify="center" align="center">
      <v-col cols="12" md="6">
        <base-material-card
          icon="mdi-calendar-check"
          color="primary"
          inline
          class="px-5 my-12 py-3"
        >
          <template v-slot:after-heading>
            <div class="title text-no-wrap font-weight-bold">
              {{ $t("userProfile.titles.tasks") }}
            </div>
          </template>

          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                color="primary"
                fixed
                bottom
                left
                v-on="on"
                @click="$router.push(`/`)"
              >
                <v-icon>mdi-puzzle</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("userProfile.buttons.gotoModules") }}</span>
          </v-tooltip>

          <v-card-text>
            <v-divider></v-divider>

            <v-list
              three-line
              v-if="filteredEvents && filteredEvents.length > 0"
            >
              <template v-for="item in filteredEvents">
                <v-list-item
                  :key="item.id"
                  :to="{
                    name: 'TaskProfile',
                    params: {
                      id: item.id,
                      uniqueId: item.uniqueId ? item.uniqueId : 'N/A',
                      taskDate: item.taskDate ? item.taskDate : 'N/A'
                    }
                  }"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-chip
                        v-if="item.type === 'recurrent'"
                        color="primary"
                        dark
                        class="mr-2"
                      >
                        {{ $t("userProfile.labels.recurrent") }}
                      </v-chip>
                      <v-chip
                        v-if="item.type === 'unique'"
                        color="primary"
                        dark
                        class="mr-2"
                      >
                        {{ $t("userProfile.labels.onetime") }}
                      </v-chip>

                      <v-chip
                        v-if="item.subtype === 'maintenance'"
                        color="secondary"
                        dark
                        class="mr-2"
                      >
                        {{ $t("userProfile.labels.maintenance") }}
                      </v-chip>
                      <v-chip
                        v-if="item.subtype === 'repair'"
                        color="secondary"
                        dark
                        class="mr-2"
                      >
                        {{ $t("userProfile.labels.repair") }}
                      </v-chip>
                      <v-chip
                        v-if="item.subtype === 'reliability'"
                        color="secondary"
                        dark
                        class="mr-2"
                      >
                        {{ $t("userProfile.labels.reliability") }}
                      </v-chip>

                      <v-chip
                        v-if="item.isDone"
                        color="success"
                        dark
                        class="mr-2"
                        >{{ $t("userProfile.labels.done") }}</v-chip
                      >
                      {{ item.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.details }} &mdash;
                      {{
                        new Intl.DateTimeFormat("es-VE", {
                          dateStyle: "full",
                          timeStyle: "long"
                        }).format(item.dateCreated.toDate())
                      }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      class="caption"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
            <div class="title my-4" v-else>
              🔧 {{ user.firstName }} has no tasks at this time ✅
            </div>
          </v-card-text>
        </base-material-card>
      </v-col></v-row
    >
  </v-container>
</template>

<script>
import UserProfile from "../Index";
import { mapState } from "vuex";
export default {
  async created() {
    await this.$store.dispatch("calendar/bindCalendar");
  },
  components: {
    UserProfile
  },
  computed: {
    filteredEvents() {
      const userId = this.user.id;
      // const responsablesArray = this.events.filter(e => e.responsables?.filter(r => r.id === userId));
      const totalEvents = [...this.events];
      const responsablesArray = [];
      totalEvents.forEach(e => {
        if ("responsables" in e) {
          e.responsables.forEach(realEvent => {
            if (realEvent.id === userId) {
              responsablesArray.push(e);
            }
          });
        }
      });
      console.log(responsablesArray)
      return responsablesArray;
    },
    ...mapState("calendar", ["events"]),
    ...mapState("calendar", ["eventProfile"]),
    ...mapState("auth", ["user"]),
    ...mapState("users", ["users"])
  }
};
</script>

<style></style>
